import { customerBaseApi } from "@/react/services/api";

const didsBaseUrl = "dids";

export const didsApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getAllDids: build.query({
      query: () => ({
        url: didsBaseUrl,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetAllDidsQuery } = didsApi;
